// 261023 E3-P3h4d1 — dòng «truy vết bước ③» dùng chung cho hàng Sổ duyệt và thẻ giám khảo. CHỈ ĐỌC + hai đường mở; không ghi gì, không gọi AI, không gửi gì cho Trợ lý.
// Nút là nút phụ (kiểu liên kết) — màn Chuyển thể chỉ có MỘT nút đỏ ở dải.
import React from 'react';
import type { TraceLine } from './localizeTraceView';

interface Props {
  line: TraceLine;
  onOpenStage?: () => void;
  onOpenScene?: () => void;
  testId?: string;
}

const LocalizeTraceNote: React.FC<Props> = ({ line, onOpenStage, onOpenScene, testId = 'localize-trace' }) => (
  <div className={`wb-trace${line.missing ? ' wb-trace-missing' : ''}`} data-testid={testId} data-missing={line.missing ? '1' : '0'}>
    <span className="wb-trace-t">ⓘ {line.text}</span>
    {onOpenStage && <button type="button" className="wb-trace-link" onClick={onOpenStage}>Mở bước ③</button>}
    {onOpenScene && <button type="button" className="wb-trace-link" onClick={onOpenScene}>Mở cảnh</button>}
  </div>
);

export default LocalizeTraceNote;
